import { createAction, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import config from '../config/config';
// Загрузим все редьюсеры чтобы можно было делать инит пейдж
import { loadMeal } from './meal';
import { loadMeetings } from './meetings';
import { loadEventeating } from './eventeating';
import { loadEating } from './eating';
import { loadAccounts } from './accounts';

import { id } from 'date-fns/locale';

export const apiCallBegan = createAction('api/callBegan');

// export const apiCallSuccess = createAction('api/callSuccess');
// export const apiCallFailed = createAction('api/callFailed');

// loading: false,
// lastFetch: null,
// hasError: false,
// error: null,

const slice = createSlice({
  name: 'api',
  initialState: {
    requests: {}
  },
  reducers: {
    callRequested: (api, action) => {
      const { actionName } = action.payload;
      api.requests[actionName] = {
        loading: true,
        error: null,
        hasError: false,
        ready: false
      };
    },
    callSuccess: (api, action) => {
      const { actionName } = action.payload;
      api.requests[actionName] = {
        loading: false,
        error: null,
        hasError: false,
        ready: true,
        lastFetch: Date.now()
      };
    },
    callFailed: (api, action) => {
      const { actionName } = action.payload.data;
      api.requests[actionName] = {
        loading: false,
        error: action.payload.error,
        ready: false,
        hasError: true
      };
    }
  }
});

export const { callRequested, callSuccess, callFailed } = slice.actions;
export default slice.reducer;

// Helper methods
export const initPage = async (pageName, dispatch) => {
  const fns = {};
  fns['loadMeal'] = loadMeal;
  fns['loadMeetings'] = loadMeetings;
  fns['loadEventeating'] = loadEventeating;
  fns['loadEating'] = loadEating;
  fns['loadAccounts'] = loadAccounts;

  const loaders =
    config.pageRequests[
      pageName.startsWith('/') ? pageName.slice(1) : pageName
    ];

  await Promise.all(
    loaders.map(async loader => {
      await dispatch(fns[loader]());
    })
  );

  // return await loaders.forEach(async loader => {
  //   // console.log('loader', loader);
  //   await dispatch(fns[loader]());
  // });
};

// Selectors

export const getPageReadyByPageSelector = pageName =>
  createSelector(
    state => state.api.requests,
    requests => {
      const actionNames =
        config.pageRequests[
          pageName.startsWith('/') ? pageName.slice(1) : pageName
        ];

      const pageRequests = Object.keys(requests)
        .map(function(r, key) {
          if (key in actionNames) {
            // return requests[r].ready;
            // console.log(requests[r]);
            // console.log(requests[r].ready);
            return requests[r].ready;
          }
        })
        .filter(item => typeof item !== 'undefined');
      // console.log('pageName', actionNames);
      // console.log('actionNames', actionNames);
      // console.log('pageRequests', pageRequests);
      // id();
      if (pageRequests.length < actionNames.length) return false;
      return pageRequests.every(x => x);
      // return pageRequests.filter(item => item).every(x => x.ready);
    }
  );

export const getLoadStateByPageSelector = pageName =>
  createSelector(
    state => state.api.requests,
    requests => {
      const actionNames =
        config.pageRequests[
          pageName.startsWith('/') ? pageName.slice(1) : pageName
        ];

      // console.log('actionNames', pageName, actionNames);
      const pageRequests = Object.keys(requests)
        .map(function(r, key) {
          if (key in actionNames) {
            return requests[r].loading;
          }
        })
        .filter(item => typeof item !== 'undefined');

      if (pageRequests.length < actionNames.length) return true;
      return pageRequests.some(x => x);
    }
  );

export const getRequestErrorsByPageSelector = pageName =>
  createSelector(
    state => state.api.requests,
    requests => {
      const actionNames =
        config.pageRequests[
          pageName.startsWith('/') ? pageName.slice(1) : pageName
        ];
      // console.log('actionNames', pageName, actionNames);
      const requestsError = Object.keys(requests).map(function(r, key) {
        if (key in actionNames) {
          return { hasError: requests[r].hasError, error: requests[r].error };
        }
      });

      // console.log(
      //   'requestsError',
      //   requestsError.filter(item => item)
      // );
      // console.log(
      //   requestsError.filter(item => item).some(x => x.hasError)
      //     ? { hasError: true, error: requestsError[0].error }
      //     : { hasError: false, error: null }
      // );
      return requestsError.filter(item => item).some(x => x.hasError)
        ? {
            hasError: true,
            error: requestsError.filter(e => e.hasError === true)[0].error
          }
        : { hasError: false, error: null };
    }
  );
